import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import I18n from 'i18n-react';

import './TravelTips.css';

const propTypes = {
  id: PropTypes.string.isRequired
};

class TravelTips extends React.Component {
  renderTitle(text) {
    return (
      <Row>
        <Col xs={12} className="TravelTips__title">
          <span>{I18n.translate(text)}</span>
        </Col>
      </Row>
    );
  }

  renderText(text) {
    return (
      <Row>
        <Col xs={12} className="TravelTips__content">
          <span>{I18n.translate(text)}</span>
        </Col>
      </Row>
    );
  }

  renderHeader(text) {
    return (
      <Row>
        <Col xs={12} className="TravelTips__header">
          <span>{I18n.translate(text)}</span>
        </Col>
      </Row>
    );
  }

  renderTravelTips() {
    return (
      <span>
        {this.renderTitle('components.travelTips.immigrationPost')}
        {this.renderText('components.travelTips.immigrationPostText')}
        {this.renderTitle('components.travelTips.antecedence')}
        {this.renderText('components.travelTips.antecedenceText')}
        {this.renderTitle('components.travelTips.checkIn')}
        {this.renderText('components.travelTips.checkInText')}
        {this.renderTitle('components.travelTips.metalDetectorInfo')}
        {this.renderText('components.travelTips.metalDetectorInfoText')}
        {this.renderTitle('components.travelTips.gadgets')}
        {this.renderText('components.travelTips.gadgetsText')}
        {this.renderTitle('components.travelTips.timeZone')}
        {this.renderText('components.travelTips.timeZoneText')}
      </span>
    );
  }

  render() {
    return (
      <div id={`TravelTips-${this.props.id}`} className="TravelTips">
        {this.renderHeader('components.travelTips.header')}
        {this.renderTravelTips()}
      </div>
    );
  }
}

TravelTips.propTypes = propTypes;

export default TravelTips;



// WEBPACK FOOTER //
// ./src/components/bookingResume/travelTips/TravelTips.jsx